export default "__VITE_ASSET__Cy93GJYE__"